import React from 'react';
import {connect} from "react-redux";
import TipsAndTricks from '../../../../../../../../../../components/tips-and-tricks';
import {guidedTours} from '../../../../../../../../../../../actions/guidedToursActions';

class T3 extends React.Component {

	constructor(props){
		super(props);

		this.closeHandler = this.closeHandler.bind(this);
	}

	t3 = null;

	componentDidMount(){
		if(this.props.isLabelsLoading === false){
			setTimeout(() => {
				this.position();

				window.addEventListener('resize', () => {
					this.position()
				});
			}, 1000);
		}
	}

	closeHandler(){
		let elm = document.getElementById("t3");
		if(elm){
			elm.style.transform = "scale(0)";
		}

		setTimeout(() => {
			this.props.setGuidedTours({
				"t3" : true,
			});
		},500);

	}

	position(){

		if(document.querySelector(".list-of-group-body .sharing-label-button svg") && document.getElementById("t3")){

			let targetCoord = document.querySelector(".list-of-group-body .sharing-label-button svg").getBoundingClientRect();
			this.t3 = document.getElementById("t3");

			/*
			* t3.offsetWidth instead of document.getElementById("t3").getBoundingClientRect().width to keep the initial width and not the one calculated by the scale effect.
			* */

			this.t3.style.left = (targetCoord.x - this.t3.offsetWidth + targetCoord.width + 7 ) + "px";
			this.t3.style.top = (targetCoord.y - this.t3.offsetHeight - 30) + "px";


			setTimeout(() => {
				this.t3.style.transform = "scale(1)";
			},500);
		}

	}

	render() {
		return (
			<TipsAndTricks id="t3" dir="down" onClose={this.closeHandler}>
				Click on
				<svg width="24" className="mx-1" version="1.1" viewBox="0 0 24 24">
					<path fill="#0297a7" d="M12,0.8c6.2,0,11.3,5,11.3,11.3s-5,11.3-11.3,11.3S0.8,18.2,0.8,12S5.8,0.8,12,0.8 M12,0C5.4,0,0,5.4,0,12 s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0L12,0z"/>
					<line fill="none" stroke="#0297a7" strokeWidth="0.75" strokeMiterlimit="10" x1="8.6" y1="12.8" x2="13.5" y2="15.2"/>
					<line fill="none" stroke="#0297a7" strokeWidth="0.75" strokeMiterlimit="10" x1="8.6" y1="10.9" x2="13.5" y2="8.5"/>
					<circle fill="#0297a7" cx="15.4" cy="7.5" r="2.2"/>
					<circle fill="#0297a7" cx="15.4" cy="16.2" r="2.2"/>
					<circle fill="#0297a7" cx="6.7" cy="11.9" r="2.2"/>
				</svg>
				to share the contact lists.
			</TipsAndTricks>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		isLabelsLoading : state.contactsGroupItemReducer.isLabelsLoading,
		guidedTours : state.guidedToursReducer.guidedTours,
		profile : state.profileReducer.getProfile
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setGuidedTours : (object) => {
			dispatch(guidedTours(object))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(T3);
